export const getPath = (url: string) => {
  if (url.split(':')[0] === "https" || url.split(':')[0] === "http") {
    const [, , , ...path] = url.split('/');
    return path.join('/');
  }
  return url;
}